import RankingStat from '../../entities/RankingStat.js';
import BattingRankingStats from '../../enums/BattingRankingStats.js';
import NumberFormatter from '../../formatters/NumberFormatter.js';
import SelectiveRankingStatCalculatorBase from './SelectiveRankingStatCalculatorBase.js';

class ExtraBaseHitRankingStatCalculator extends SelectiveRankingStatCalculatorBase {
    constructor(numberFormatter) {
        if (typeof(numberFormatter) !== 'undefined' && !(numberFormatter instanceof NumberFormatter)) {
            throw new TypeError('numberFormatter must be an instance inheriting from NumberFormatter class');
        }
        super([
            BattingRankingStats.ExtraBaseHits
        ]);

        this.dependencies = [
            BattingRankingStats.TwoBaseHits, BattingRankingStats.ThreeBaseHits, BattingRankingStats.HomeRuns
        ];
        this.numberFormatter = numberFormatter || new NumberFormatter(3);
    }

    listDependencies(parameter) {
        // TODO - maybe concat ?
        return this.dependencies;
    }

    calculateStat(parameter, dependencies) {
        const doubles = dependencies[0];
        const triples = dependencies[1];
        const homeRuns = dependencies[2];

        const doublesValue = (!doubles || doubles.isEmpty()) ? 0 : doubles.value;
        const triplesValue = (!triples || triples.isEmpty()) ? 0 : triples.value;
        const homeRunsValue = (!homeRuns || homeRuns.isEmpty()) ? 0 : homeRuns.value;

        // @see https://www.mlb.com/glossary/standard-stats/extra-base-hit
        // @see https://baseball.fandom.com/wiki/Extra_base_hit
        // An extra-base hit is defined as any hit that is not a single, meaning doubles, triples and home runs are all considered extra-base hits.
        // They are a good stat to look at to evaluate an offensive player's power -- and in some cases, his speed.
        const xbh = doublesValue + triplesValue + homeRunsValue;

        if (!xbh) {
            return null;
        }

        // TODO - weight should be the same for both, otherwise we will need to calculate it with common denominator
        return RankingStat.fromParameter(
            parameter,
            this.numberFormatter.format(
                xbh
            ),
            xbh
        );
    }
}

export default ExtraBaseHitRankingStatCalculator;